import React, { useEffect } from 'react'
import './index.less'
import RowHeader from '../RowHeader'
import { Form, Input, Radio, Space } from 'antd'
import ExperEnv from '../ExperEnv'
import { CourseTreeCategory, CourseTreeType } from '@/utils/commonTypes'
import { StepEnum } from '.'

import { ExclamationCircleOutlined } from '@ant-design/icons'

type BaseProps = {
    formData: any
    editType: 'stage' | 'chapter' | 'content' | null
    changeStep: (step: StepEnum) => void
    update?: boolean                   // 添加还是编辑  默认添加
    experEnvList: any[]             // 实验环境列表
    updatePort?: (type: 'update' | 'add', ports: any, value?: any) => void// 更新端口
    selected?: any
    disabledUpdate?: boolean        // 是否禁用去升级
    labCode: string
}

const Base: React.FC<BaseProps> = (props) => {

    const { formData, editType, changeStep, update, experEnvList, updatePort, selected, labCode, disabledUpdate } = props

    const form = Form.useFormInstance()
    const category = Form.useWatch('category', form)

    useEffect(() => {
        form.setFieldsValue({...formData, template: undefined})
    }, [formData])
    

    return (
        <>
            <RowHeader title='基础信息' style={{ marginBottom: '16px' }} />
            {
                editType !== 'content' && <Form.Item
                    label='目录层级'
                    name='category'
                    rules={[
                        { required: true, message: '请选择目录层级', validateTrigger: "onSubmit", whitespace: true },
                    ]}
                    validateFirst
                >
                    <Radio.Group disabled={update || editType !== null}>
                        <Space size={20}>
                            {/* 理论上阶段和章值是一样，这边是为了区分，保存的时候会还原 */}
                            <Radio value={CourseTreeType.STAGE}>阶段</Radio>
                            <Radio value={CourseTreeType.CHAPTER}>章</Radio>
                            <Radio value={CourseTreeCategory.CONTENT}>小节</Radio>
                        </Space>
                    </Radio.Group>
                </Form.Item>
            }


            <Form.Item
                label={editType !== 'content' ? '层级名称' : '小节名称'}
                name='title'
                rules={[
                    { required: true, message: `请输入${editType !== 'content' ? '层级名称' : '小节名称'}`, validateTrigger: "onSubmit", whitespace: true },
                    {
                        validator(_, value: string) {
                            if (value.includes('#') || value.includes('%')) {
                                return Promise.reject(`请输入除“#”、“%”外的100个字符`)
                            }
                            if (!/^[^\\/:*?`'"<>|\r\n\t]+$/g.test(value)) {
                                return Promise.reject(`当前输入包含特殊字符`)
                            }
                            return Promise.resolve()
                        }, validateTrigger: "onSubmit"
                    }
                ]}
                validateFirst
            >
                <Input showCount maxLength={100} allowClear placeholder={`请输入${editType !== 'content' ? '层级名称' : '小节名称'}`} />
            </Form.Item>

            {
                (editType === 'content' || category === CourseTreeCategory.CONTENT) && <Form.Item
                    label='内容类型'
                    name='type'
                    extra={<Space size={2}>
                        <ExclamationCircleOutlined />
                        <span>内容类型保存后无法变更</span>
                    </Space>}
                    rules={[
                        { required: true, message: '请选择内容类型', validateTrigger: "onSubmit", whitespace: true },
                    ]}
                    validateFirst
                >
                    <Radio.Group disabled={(update && selected?.describe?.type)}>
                        <Space size={20}>
                            <Radio value={CourseTreeType.TEXT}>文档</Radio>
                            <Radio value={CourseTreeType.VIDEO}>视频</Radio>
                            <Radio value={CourseTreeType.EXAM}>考试</Radio>
                            <Radio value={CourseTreeType.NOTEBOOK}>notebook</Radio>
                        </Space>
                    </Radio.Group>
                </Form.Item>
            }

            <Form.Item
                label='添加位置'
                name='path'
                labelCol={{ span: 3 }}
            >
                <Input disabled />
            </Form.Item>

            <ExperEnv labCode={labCode} disabledUpdate={disabledUpdate} updatePort={updatePort} selectEnv={() => { changeStep(StepEnum.ENV) }} experEnvList={experEnvList} />
        </>
    )
}

export default Base